"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShootSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const geography_1 = require("../utility/geography");
const mongo_1 = require("../utility/mongo");
exports.ShootSchema = joi_1.default.object({
    start: joi_1.default.date().required(),
    end: joi_1.default.date().required(),
    status: joi_1.default.string().allow('confirmed', 'cancelled').required(),
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    // FIXME: hundreds of shoots without googleCalendarDescription and googleCalendarSummary
    googleCalendarDescription: joi_1.default.string(),
    googleCalendarSummary: joi_1.default.string(),
    // TODO: on staging we don't have calendar, so we have nulls here
    googleEventId: joi_1.default.string().allow(null).required(),
    googleCalendarId: joi_1.default.string().allow(null).required(),
    location: joi_1.default.object({
        address: joi_1.default.string().required(),
        originalAddress: joi_1.default.string().allow(null).optional(),
        // FIXME: got A LOT of shoots without it
        addressComponents: joi_1.default.object({
            city: joi_1.default.string(),
            country: joi_1.default.string().required(),
            // No shoots without it in 2021, but this would fail for shoots created in 2020.11 and before
            countryCode: joi_1.default.string().required(),
            postalCode: joi_1.default.string(),
            street: joi_1.default.string(),
            streetNumber: joi_1.default.string()
        }).allow(null),
        geometry: geography_1.PointSchema.required(),
        name: joi_1.default.string().allow('', null),
        timeZoneId: joi_1.default.string().required()
    }).required(),
    orderUuid: joi_1.default.string().required(),
    // TODO: get rid of this one in favor of photographerUuid
    photographerId: mongo_1.ObjectIdSchema.allow(null),
    uploadUrl: joi_1.default.string(),
    uuid: joi_1.default.string().uuid().required(),
    locationReminderSent: joi_1.default.boolean()
}).meta({ className: 'Shoot' });
//# sourceMappingURL=ShootSchema.js.map